import type {PostToyOption} from 'components/richTextEditor/TipTap/extensions/easterEggToys';

/**
 * The toys staff may put in a forum post: Look & feel palette widgets, by
 * their palette id. Kept apart from the palette so the entry bundle carries
 * only these names, not the toys.
 */
export const POST_TOY_OPTIONS: readonly PostToyOption[] = [
  {id: 'rain-cloud', label: 'Rain cloud', isWholePage: true},
  {id: 'ollie-porch', label: "Ollie's porch"},
  {id: 'toy-die', label: 'Plush die'},
];
